import TabPanel, { Item } from "devextreme-react/tab-panel";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useState } from "react";
import EmailLocalization from "./email-localization/email-localization";

const EmailNotificationManagement = () => {
    const { t } = useTranslation();
    const params = useParams();
    const [selectedIndex, setSelectedIndex] = useState(0);

    return (
        <TabPanel id="tabs"
            selectedIndex={selectedIndex}
            onSelectionChanged={(e: any) => setSelectedIndex(e.component.option("selectedIndex"))}
        >
            {params.id && (<Item title={t("email_localization")}>
                <EmailLocalization emailNotificationId={params.id} ></EmailLocalization>
            </Item>)}
        </TabPanel>
    )
}
export default EmailNotificationManagement